<template>
  <!-- content start -->
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#dadada',
      '--bg-theme': bgTheme
    }"
    class="content custom-quiz"
  >
    <!-- <QuizHeader /> -->
    <QuizHeader :title="quizTitle" />
    <div
      :style="{ backgroundColor: isDarkTheme ? topBgColor : bgTheme }"
      class="quiz-head-h"
    ></div>
    <div
      class="quiz-details-block"
      <div
      :style="{
        marginRight: '15px',
        marginLeft: '15px',
        marginTop: '65px',
        position: 'relative',
        zIndex: 1,
        overflowY: 'auto',
        maxHeight:
          game_data.other_banners.length > 0
            ? 'calc(100vh - 110px)'
            : 'calc(100vh - 20px)',
        marginBottom: '70px'
      }"
    >
      <div
        class="quiz-image-1 w-full"
        style="background-color: #ffffff; border-radius: 15px; height: 170px;"
      >
        <img
          style="border-radius: 15px;"
          :src="game_data.banner_url"
          alt="quiz"
        />
      </div>

      <!-- Custom Quiz Section Start -->
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
        }"
        class="custom-quiz-section w-full"
        style="margin-top: 15px; margin-bottom: 110px; "
        v-if="game_data.other_banners.length === 0"
      >
        <div class="detail-header w-full">
          <div
            @click="showDetails"
            :style="{
              borderBottom: show_detail ? '1px solid ' + ('var(--description-color, var(--bg-color))') : 'none',
              color: show_detail ? ('var(--description-color, var(--bg-color))') : ''
            }"
          >
            <span style="font-size: 16px;">PRIZE </span>
          </div>
          <div
            @click="showLeaderBoard"
            :style="{
              borderBottom: !show_detail ? '1px solid ' + ('var(--description-color, var(--bg-color))') : 'none',
              color: !show_detail ? ('var(--description-color, var(--bg-color))') : ''
            }"
          >
            <span style="font-size: 16px">LEADERBOARD </span>
          </div>
        </div>
        <!-- Custom Timer Section Start -->
        <div
          class="custom-timer-section text-center"
          v-if="show_detail === true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            :style="{
              width: '18px',
              fill: !game_data.is_live ? '#097969' : topBgColor
            }"
          >
            <path
              d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3
             371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4
             0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9
             141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"
            />
          </svg>
          <span v-if="game_data.is_live" style="font-size: 14px;">
            Ends in</span
          >
          <span
            style="font-size: 15px; font-weight: 800;"
            v-else-if="!game_data.is_live && endTime > new Date()"
            >Starts in</span
          >
          <span v-else-if="!game_data.is_live && endTime < new Date()"
            >Quiz ended</span
          >

          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: center;
              margin-top: 10px;
            "
            class="border-bottom padding-bottom-10"
          >
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
              v-if="displayDays > 0"
            >
              <span class="countdown-amount">
                {{ displayDays }}
              </span>
              <span>Days</span>
            </div>
            <div
              class="is-countdown"
              style="margin-left: 10px; margin-right: 10px"
              v-if="displayDays > 0"
            >
              <span class="countdown-amount"> : </span>
            </div>
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
            >
              <span class="countdown-amount">
                {{ displayHours }}
              </span>
              <span>Hrs</span>
            </div>
            <div
              class="is-countdown"
              style="margin-left: 10px; margin-right: 10px"
            >
              <span class="countdown-amount"> : </span>
            </div>
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
            >
              <span class="countdown-amount">
                {{ displayMinutes }}
              </span>
              <span>Min</span>
            </div>
            <div
              class="is-countdown"
              style="margin-left: 10px; margin-right: 10px"
            >
              <span class="countdown-amount"> : </span>
            </div>
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
            >
              <span class="countdown-amount">
                {{ displaySeconds }}
              </span>
              <span>Sec</span>
            </div>
          </div>

          <!-- Spinner Section Start -->
          <div
            style="background-color: #ffffff;"
            class="spinner-section padding-top-5"
            v-for="(item, index) in game_data.other_banners"
          >
            <div
              v-on:click="handleDeeplink(item.deeplink)"
              class="spinner-block"
            >
              <img :src="item.image_url" alt="spinner" class="img-fluid" />
            </div>
          </div>
          <!-- Spinner Section End -->

          <div
            class="ranking border-bottom padding-bottom-5 margin-bottom-10"
            v-if="game_data.other_banners.length === 0"
          >
            <h6
              style="color: #373535; font-weight: bolder; font-size: 16px; font-weight: 700;"
            >
              Rankings
            </h6>
            <div class="table-responsive-sm">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <td
                      :style="{
                        borderTop: 'none',
                        color: 'var(--description-color, var(--bg-color))'
                      }"
                      class="text-left"
                    >
                      Rank
                    </td>
                    <td
                      :style="{
                        borderTop: 'none',
                        textAlign: 'end',
                        color: 'var(--description-color, var(--bg-color))'
                      }"
                    >
                      {{ game_data.currency_label }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :style="{
                      backgroundColor: isDarkTheme ? mainBgColor : '#dadada'
                    }"
                    v-for="prize in game_data.prizes"
                  >
                    <td
                      :style="{ color: 'var(--description-color, var(--bg-color))' }"
                      class="text-left"
                      v-if="prize.from_rank === prize.to_rank"
                    >
                      {{ prize.to_rank }}
                    </td>
                    <td
                      :style="{ color: 'var(--description-color, var(--bg-color))' }"
                      class="text-left"
                      v-else
                    >
                      {{ prize.from_rank }} to {{ prize.to_rank }}
                    </td>
                    <td
                      :style="{
                        textAlign: 'end',
                        color: 'var(--description-color, var(--bg-color))'
                      }"
                      v-if="prize.from_prize === prize.to_prize"
                    >
                      {{ prize.to_prize }}
                    </td>
                    <td
                      :style="{
                        textAlign: 'end',
                        color: 'var(--description-color, var(--bg-color))'
                      }"
                      v-else
                    >
                      {{ prize.from_prize !== 0 ? prize.from_prize : "Upto -" }}
                      {{ prize.from_prize !== 0 ? "-" : "" }}
                      {{ prize.to_prize }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :style="{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: 'var(--description-color, var(--bg-color))'
                      }"
                      class="text-left"
                    >
                      Total Prize Pool:
                    </td>
                    <td
                      :style="{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        padding: '10px 5px',
                        color: 'var(--description-color, var(--bg-color))'
                      }"
                    >
                      Up to {{ game_data.prize }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            class="details padding-top-10"
            v-if="game_data.rules && game_data.other_banners.length === 0"
          >
            <h6 style="font-weight: 700; font-size: 18px">
              Details
            </h6>
            <div
              v-html="game_data.rules"
              class="rules-text"
              style="
                white-space: normal;
                text-align: -webkit-left;
                padding: 1rem 1.9rem;
              "
            ></div>
          </div>
        </div>
        <!-- Custom Timer Section End -->

        <!-- Leader Board Div-->
        <div v-if="show_detail === false" style="min-height: 54vh">
          <div v-if="game_data.is_live">
            <span style="font-weight: bold; font-size: 16px">
              Winners will be announced soon. Please check back Later</span
            >
          </div>
          <div v-if="!game_data.is_live" class="padding-top-5">
            <span style="font-weight: bold; font-size: 15px">
              You have not participated in any quiz yet.</span
            >
          </div>
        </div>
      </div>
      <!-- Custom Quiz Section End -->

      <div v-else>
        <div class="custom-timer-section text-center">
          <span v-if="game_data.is_live" style="color: #fff"> Ends in</span>
          <span v-else style="color: #fff">Starts in</span>
          <div
            style="
              color: #fff;
              display: flex;
              flex-direction: row;
              justify-content: center;
              margin-top: 5px;
            "
          >
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
              v-if="displayDays > 0"
            >
              <span class="countdown-amount"> {{ displayDays }}d </span>
            </div>
            <div
              class="is-countdown"
              style="margin-left: 10px; margin-right: 10px"
              v-if="displayDays > 0"
            >
              <span class="countdown-amount">: </span>
            </div>
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
            >
              <span class="countdown-amount"> {{ displayHours }}h </span>
            </div>
            <div
              class="is-countdown"
              style="margin-left: 10px; margin-right: 10px"
            >
              <span class="countdown-amount">: </span>
            </div>
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
            >
              <span class="countdown-amount"> {{ displayMinutes }}m </span>
            </div>
            <div
              class="is-countdown"
              style="margin-left: 10px; margin-right: 10px"
            >
              <span class="countdown-amount">: </span>
            </div>
            <div
              class="is-countdown"
              style="display: flex; flex-direction: column"
            >
              <span class="countdown-amount"> {{ displaySeconds }}s </span>
            </div>
          </div>

          <div
            style="background-color: #ffffff; border-radius: 15px;"
            class="spinner-section padding-top-5"
            v-for="(item, index) in game_data.other_banners"
          >
            <div
              v-on:click="handleDeeplink(item.deeplink)"
              class="spinner-block"
            >
              <img
                style="border-radius: 15px;"
                :src="item.image_url"
                alt="spinner"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="toast"
      class="font-bold pos-fixed pos-center-hor pull-down"
      style="
        width: 80%;
        padding: 5px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.5);
        margin-bottom: 70px;
        color: white;
        display: none;
        z-index: 999;
      "
    ></div>

    <footer
      :style="{ backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff' }"
      class="footer"
      style="
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: 30px;
        /* border-top: 1px solid #efefef; */
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
      "
    >
      <!-- Footer content remains the same -->
      <div
        class=""
        style="
          margin-right: auto;
          margin-left: auto;
          width: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
        "
        v-if="
          !game_data.is_live &&
            !game_data.has_played &&
            !game_data.notified &&
            new Date(game_data.starts_at) > new Date()
        "
      >
        <div
          v-if="game_data.show_theme == 'banner'"
          v-on:click="notifyUser()"
          class="btn text-uppercase"
          style="
            padding: 8px 0;
            width: 150px;
            height: 20px;
            border-radius: 50px;
          "
          role="button"
          :style="{
            backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
            color: isDarkTheme ? headingTextColor : '#ffffff'
          }"
        >
          Notify Me
        </div>

        <div
          v-else
          style="
            color: #fff;
            padding: 8px 10px;
            width: 150px;
            margin: auto;
            border-radius: 50px;
            text-transform: uppercase;
          "
          @click.prevent=""
          :class="{ disabled: true }"
          :style="{ background: '#DADADA' }"
        >
          Play Quiz Now
        </div>
      </div>

      <div
        class=""
        style="
          margin-right: auto;
          margin-left: auto;
          width: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
        "
        v-if="
          !game_data.is_live &&
            !game_data.has_played &&
            game_data.notified &&
            new Date(game_data.starts_at) > new Date()
        "
      >
        <div
          style="
            color: #fff;
            padding: 8px 10px;
            width: 150px;
            margin: auto;
            border-radius: 50px;
             text-transform: uppercase;
          "
          @click.prevent=""
          :class="{ disabled: true }"
          :style="{ background: '#DADADA' }"
        >
          Play Quiz Now
        </div>
      </div>

      <div
        class=""
        style="
          margin-right: auto;
          margin-left: auto;
          width: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
        "
        v-if="
          game_data.is_live && !game_data.has_played && endTime > new Date()
        "
      >
        <router-link
          :to="{
            name: 'quiz_questions',
            params: { id: game_data.id, banner_url: game_data.banner_url }
          }"
        >
          <a
            class="btn text-uppercase"
            style="
              padding: 8px 10px;
              width: 150px;
              height: 20px;
              border-radius: 50px;
               text-transform: uppercase;
            "
            role="button"
            :style="{
              backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
            >Play Quiz Now
          </a>
        </router-link>
      </div>

      <div
        class=""
        style="
          margin-right: auto;
          margin-left: auto;
          width: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
        "
        v-if="
          game_data.has_played || (!game_data.is_live && endTime < new Date())
        "
        :key="game_data.is_live"
      >
        <div
          style="
            color: #fff;
            padding: 8px 10px;
            width: 150px;
            margin: auto;
            border-radius: 50px;
             text-transform: uppercase;
          "
          @click.prevent="game_data.has_played"
          :class="{ disabled: game_data.has_played }"
          :style="{
            background: game_data.has_played
              ? '#DADADA'
              : !game_data.is_live
              ? '#DADADA'
              : 'var(--bg-color)'
          }"
        >
          Play Quiz Now
        </div>
      </div>

      <div
        :style="{ backgroundColor: topBgColor }"
        v-on:click="sharemessage(game_data.share_message)"
        v-if="game_data.share_message"
        class="share-div"
      >
        <img src="@/assets/share.svg" class="share-img" />
      </div>
    </footer>
  </div>
  <!-- content end -->
</template>

<script>
// import Tasks from '../components/Tasks'
import QuizHeader from "@/components/quiz-header";
import { globals } from "@/mixins/globals";
import axios from "axios";
export default {
  mixins: [globals],
  name: "quiz-details-custom",
  props: {
    date: {
      type: String
    }
  },
  components: {
    // Quiz
    // AddTask,
    // Tasks,
    QuizHeader
  },
  data: () => ({
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    id: "",
    game_data: "",
    show_detail: true,
    endTime: null,
    valchangeCall: null,
    timer: () => {}
  }),
  computed: {
    quizId() {
      return this.$route.params.id;
    },
    quizTitle() {
      // return this.$route.params.title;
      return this.$store.state.quizDetailsTitle;
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
    is_live() {
      let d1 = new Date();
      let d2 = new Date(this.game_data.starts_at);
      let diff = d2 - d1;
      if (diff === 0) {
        this.game_data.is_live = true;
      }
      return this.game_data.is_live;
    }
  },
  methods: {
    sharemessage(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      document.getElementById("toast").style.width = "100px";
      document.getElementById("toast").innerHTML = "Copied";
      document.getElementById("toast").style.display = "block";
      setTimeout(function() {
        document.getElementById("toast").style.width = 80 + "%";
        document.getElementById("toast").style.display = "none";
      }, 2000);
    },
    notifyUser() {
      var self = this;
      var url =
        self.$store.getters.flyyDomain +
        "/v1/notify_user/" +
        self.id +
        "?notify_type=API";
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            // Update the notified state in game_data
            this.game_data.notified = true;

            // Show toast message
            document.getElementById("toast").innerHTML = data.message;
            document.getElementById("toast").style.display = "block";
            setTimeout(function() {
              document.getElementById("toast").style.display = "none";
            }, 2000);
          } else {
            console.log("Error Notifying User");
          }
        });
    },
    // notifyUser() {
    //   var self = this;
    //   var url =
    //     self.$store.getters.flyyDomain +
    //     "/v1/notify_user/" +
    //     self.id +
    //     "?notify_type=API";
    //   var headers = self.$store.getters.headers;
    //   axios
    //     .get(url, {
    //       headers: headers
    //     })
    //     .then(resp => {
    //       if (resp.status == 200) {
    //         var data = resp.data;
    //         // console.log(data)
    //         this.game_data.notified = true;

    //         document
    //           .getElementsByTagName("footer")[0]
    //           .getElementsByTagName(
    //             "div"
    //           )[0].innerHTML = `<div class="" style="margin-right: 15px; margin-left: 15px;"><div style="color: #fff; padding: 8px 0; background: grey !important; width: 150px; margin: auto; border-radius: 50px;">Play Quiz Now</div></div>`;
    //         document.getElementById("toast").innerHTML = data.message;
    //         document.getElementById("toast").style.display = "block";
    //         setTimeout(function() {
    //           document.getElementById("toast").style.display = "none";
    //         }, 2000);
    //       } else {
    //         console.log("Error Notifying User");
    //       }
    //     });
    // },
    handleDeeplink(deeplink) {
      // deeplink = "https://www.google.com"
      if (deeplink) {
        window.open(deeplink, "_blank");
      }
    },
    timeUpdate() {
      if (this.distance < 0) {
        clearInterval(this.timer);
        return;
      }
      const seconds = parseInt(
        Math.floor(this.distance % this._minutes) / this._seconds
      );
      const minutes = parseInt(
        Math.floor(this.distance % this._hours) / this._minutes
      );
      const days = parseInt(Math.floor(this.distance / this._days));
      const hours = parseInt(
        Math.floor(this.distance % this._days) / this._hours
      );

      this.displayMinutes = minutes < 10 ? "0" + minutes : minutes;
      this.displaySeconds = seconds < 10 ? "0" + seconds : seconds;
      this.displayHours = hours < 10 ? "0" + hours : hours;
      this.displayDays = days < 10 ? "0" + days : days;
      this.distance = this.distance - 1000;
    },
    showRemaining(onChange) {
      if (onChange) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (this.distance < 0) {
          clearInterval(this.timer);

          return;
        }
        const seconds = parseInt(
          Math.floor(this.distance % this._minutes) / this._seconds
        );
        const minutes = parseInt(
          Math.floor(this.distance % this._hours) / this._minutes
        );
        const days = parseInt(Math.floor(this.distance / this._days));
        const hours = parseInt(
          Math.floor(this.distance % this._days) / this._hours
        );

        this.displayMinutes = minutes < 10 ? "0" + minutes : minutes;
        this.displaySeconds = seconds < 10 ? "0" + seconds : seconds;
        this.displayHours = hours < 10 ? "0" + hours : hours;
        this.displayDays = days < 10 ? "0" + days : days;
        this.distance = this.distance - 1000;
      }, 1000);
    },
    getTotalPoolPrize() {
      let poolprize = 0;
      this.game_data.prizes.forEach(i => {
        let people = 0;
        if (i.from_rank === i.to_rank) {
          people = 1;
        } else {
          people = i.to_rank - i.from_rank + 1;
        }
        poolprize += people * i.to_prize;
      });
      return poolprize;
    },
    fetchQuizDetails(valChangeCall) {
      const storedQuizData = JSON.parse(localStorage.getItem("customQuizData"));
      console.log("Custom Quiz Details", storedQuizData);

      var self = this;
      this.valchangeCall = valChangeCall;
      var url = self.$store.getters.flyyDomain + "/v2/quiz_game/" + self.id;
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            self.game_data = data.game;
            //console.log(self.game_data)
            this.$store.state.quizDetailsTitle = self.game_data.title;
            var now = new Date();
            var end = new Date(self.game_data.starts_at);

            if (self.game_data.is_live) {
              now = new Date();
              end = new Date(self.game_data.ends_at);
            }
            self.endTime = end;
            self.distance = end - now;
            self.showRemaining(valChangeCall);
          } else {
            console.log("Error fetching the Quiz Details");
          }
        });
    },
    showDetails() {
      this.show_detail = true;
    },
    showLeaderBoard() {
      this.show_detail = false;
    }
  },
  async created() {
    // this.$emit('handleShowFooter', true);
    /* if (this.$route.params.id) {
      this.$store.state.quizDetailsId = this.$route.params.id;
    }
    this.id = this.$store.state.quizDetailsId */
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$store.state.quizDetailsId = this.$route.params.id;
    }
    this.id = this.$store.state.quizDetailsId;
    this.$store.state.showQuizHistoryMenu = true;
    this.fetchQuizDetails(false);
  },
  mounted() {
    console.log("Quiz ID:", this.$route.params.id);
    console.log("Quiz Title:", this.$route.params.title);
    /*  this.$store.state.showQuizHistoryMenu = true;
    this.fetchQuizDetails(false); */
  },
  watch: {
    distance: function(val) {
      if (val <= 0 && !this.valchangeCall) {
        this.fetchQuizDetails(true);
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

.content.custom-quiz {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.custom-quiz-section {
  background: #ffffff;
  border-radius: 15px;
}

.quiz-details-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

.quiz-details-block::-webkit-scrollbar {
  width: 6px;
}

.quiz-details-block::-webkit-scrollbar-track {
  background: transparent;
}

.quiz-details-block::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

.w-full {
  width: 100% !important;
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.detail-header > div {
  width: 50%;
  padding: 10px 1px;
}

.detail-header > span {
  color: var(--bgcolor);
}

.ranking {
  padding: 0.75rem;
  margin: 0.25rem;
}

.rules-text {
  overflow-x: scroll;
  overflow-wrap: break-word;
  scrollbar-width: none;
}

.rules-text span {
  white-space: normal !important;
}

.highlight {
  /* border-bottom: 1px solid var(--bg-color); */
  border-bottom: 1px solid var(--bg-theme);
  /* color: #08188c; */
  color: var(--bg-theme);
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .quiz-head-h {
    height: 350px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .quiz-image-1 img {
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
  }

  .share-div {
    width: 40px;
    height: 35px;
    margin: auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    right: 10px;
    top: -2px;
  }

  .share-img {
    width: 15px;
    height: 15px;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .share-img {
    width: 15px;
    height: 15px;
  }
  .share-div {
    width: 40px;
    height: 35px;
    margin: auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    right: 10px;
    top: -2px;
  }
  .quiz-image-1 img {
    width: 100%;
    /* height: 170px; */
    height: 100%;
    margin-bottom: 10px;
  }

  .quiz-head-h {
    height: 370px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
}
</style>
